/**
 * Commodity → monoline Phosphor (ph:*) icon mapping.
 * Single source of truth so Home, PublicCommodities and any future surface stay
 * consistent (no emoji). Render with <Icon icon={iconForCommodity(c)} /> from @iconify/react.
 */

export const CATEGORY_ICONS = {
  CAT001: 'ph:grains',             // Rice/Paddy
  CAT002: 'ph:plant',              // Maize
  CAT003: 'ph:grains',             // Sorghum
  CAT004: 'ph:grains',             // Millet
  CAT005: 'ph:grains',             // Wheat
  CAT006: 'ph:plant',              // Cowpea
  CAT007: 'ph:plant',              // Soyabean
  CAT008: 'ph:circles-three',      // Barbara Nut
  CAT009: 'ph:circles-three',      // Groundnut
  CAT010: 'ph:dots-three-outline', // Sesame
  CAT011: 'ph:pepper',             // Pepper
  CAT012: 'ph:plant',              // Ginger/Turmeric
  CAT013: 'ph:flower',             // Hibiscus
  CAT014: 'ph:tree',               // Locust Beans
};

export const iconForCommodity = (c) => CATEGORY_ICONS[c?.category] || 'ph:plant';
